import "./bootstrap-custom.css";
import "./index.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { HashRouter as Router } from "react-router-dom";
import HttpsRedirect from 'react-https-redirect';

library.add(fas, far, fab);

ReactDOM.render(
  <HttpsRedirect>
    <React.StrictMode>
      <Router>
        <App />
      </Router>
    </React.StrictMode>
  </HttpsRedirect>,
  document.getElementById("root")
);
